<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="SR编号" prop="srNumber">
                    <el-input v-model="queryCondition.srNumber" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="回收项目简介" prop="recoveryProjectSummary">
                    <el-input v-model="queryCondition.recoveryProjectSummary" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品名称" prop="eightBitCodeName">
                    <el-input v-model="queryCondition.eightBitCodeName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态" prop="status">
                    <ic-select clearable table="TT_QSPI_STOCK_REC_HEADER" field="STATUS" placeholder="请选择" v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="Facility名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="QSPI_STOCKRECOVER_ADD">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="QSPI_STOCKRECOVER_DEL">删除</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="QSPI_STOCKRECOVER_EXPORT">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" :checkboxConfig="{checkMethod: selectable, highlight: true}" @cell-click="cellClick" :cell-class-name='setCellClass' max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="SR编号" resizable min-width="80" field="srNumber">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row)">{{row.srNumber}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="回收项目简介" resizable min-width="120" field="recoveryProjectSummary"></ux-table-column>
        <ux-table-column align="center" title="发起日期" resizable min-width="180" field="recoveryStartDate"></ux-table-column>
        <ux-table-column align="center" title="等级" resizable min-width="100" field="srGrade"></ux-table-column>
        <ux-table-column align="center" title="产品名称" resizable min-width="90" field="eightBitCodeName"></ux-table-column>
        <ux-table-column align="center" title="产品批次" resizable min-width="90" field="batchNo"></ux-table-column>
        <ux-table-column align="center" title="Facility名称" resizable min-width="90" field="facilityName"></ux-table-column>
        <ux-table-column align="center" title="原因" resizable min-width="90" field="reason"></ux-table-column>
        <ux-table-column align="center" title="回收数量(箱)" resizable min-width="90" field="recoveryQty"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="90" field="statusI18n"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog"></detailDialog>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import StockRecoveryApi from "@/api/StockRecovery/index";
import detailDialog from './detail.vue'
import paginationMixin from '@/mixins/pagitionMixin';
import { fileService } from "@/api/common/file-utils";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: 'stockRecoveryPage',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    detailDialog
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      multipleSelection: [],
      ttQspiStockRecItemIdList: [],
      ttQspiStockRecHeaderIdList: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        srNumber: "",
        recoveryProjectSummary: "",
        eightBitCodeName: "",
        status: "",
        facilityName: ""
      },
      isShow: false,
      showDetailDialog: false,
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    StockRecoveryApi.findListPage(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  created() {
    // this.queryData();
  },
  methods: {
    queryData() {
      StockRecoveryApi.findListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onDetail(row) {
      if (row.status == 'Processing') {
        this.$router.push({
          path: '/qspiStockRecovery/detail',
          query: {
            ttQspiStockRecHeaderId: row.ttQspiStockRecHeaderId,
            from: "edit"
          }
        })
      } else {
        this.$router.push({
          path: '/qspiStockRecovery/view',
          query: {
            ttQspiStockRecHeaderId: row.ttQspiStockRecHeaderId,
          }
        })
      }
    },
    onAdd() {
      this.$router.push({
        path: '/qspiStockRecovery/detail',
        query: {
          from: 'add'
        }
      })
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.ttQspiStockRecItemIdList = []
      this.ttQspiStockRecHeaderIdList = []
      val.forEach(ele => {
        this.ttQspiStockRecItemIdList.push(ele.ttQspiStockRecItemId)
        this.ttQspiStockRecHeaderIdList.push(ele.ttQspiStockRecHeaderId)
      })
    },
    onDel() {
      if (this.ttQspiStockRecHeaderIdList.length == 0) {
        this.$my_message('请先选择数据后再操作', 'error');
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.status == 'Processing'
      })
      if (!flag) {
        this.$my_message("只有状态为'进行中'SR可以进行删除", 'error');
        return false
      }
      //您确定要删除所选记录吗？
      this.$confirm('勾选任一SR编号会将整单删除,您确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        StockRecoveryApi.delete(this.ttQspiStockRecHeaderIdList).then(res => {
          console.log('res', res);
          if (res.code === '200') {
            this.$my_message("删除成功", 'success');
            this.ttQspiStockRecHeaderIdList = []
            this.$refs['plxTable'].clearSelection()
            this.queryData()
          }
        });
      })
    },
    onExport() {
      this.$set(this.queryCondition, 'ttQspiStockRecItemIdList', this.ttQspiStockRecItemIdList)
      StockRecoveryApi.dataListDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'Stock Recovery_Report.xlsx');
        this.ttQspiStockRecItemIdList = []
        this.$set(this.queryCondition, 'ttQspiStockRecItemIdList', [])
        this.$refs['plxTable'].clearSelection()
      });
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        srNumber: "",
        recoveryProjectSummary: "",
        eightBitCodeName: "",
        status: "",
        facilityName: ""
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
